export default "__VITE_ASSET__1f13b83b__"